import { Controller } from '@hotwired/stimulus'
import { upperFirst } from 'lodash'

export default class extends Controller {
  static targets = ['fields', 'fieldsAbsolute', 'fieldsIntensity', 'inputDataType', 'inputStartYear', 'inputEndYear']

  connect() {
    const inputs = this.inputDataTypeTargets.map(label => label.querySelector('input'))
    const dataType = inputs.find(input => input.checked).value

    this.#showFieldsForDataType(dataType)
  }

  toggleFields(e) {
    const dataType = e.target.value
    this.#showFieldsForDataType(dataType)
  }

  updateYears(e) {
    const select = e.target
    const option = Array.from(select.options).find(o => o.value === select.value)

    this.inputStartYearTarget.value = option.dataset.startYear
    this.inputEndYearTarget.value = option.dataset.endYear
  }

  #showFieldsForDataType(dataType) {
    this.fieldsTargets.forEach(fields => {
      fields.classList.add('hidden')
      fields.setAttribute('disabled', 'disabled')
    })

    const targetPredicateName = `hasFields${upperFirst(dataType)}Target`
    const targetName = `fields${upperFirst(dataType)}Target`

    if (this[targetPredicateName]) {
      this[targetName].classList.remove('hidden')
      this[targetName].removeAttribute('disabled')
    }
  }
}
